import { useEffect, useRef } from "react";
import { servicesData } from "@/mocks/home";

export default function Services() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll("[data-animate]").forEach((child, i) => {
              setTimeout(() => {
                child.classList.add("animate-fade-in-up");
                child.classList.remove("opacity-0");
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="services"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-[#f8f9fb] section-padding"
    >
      <div className="container-wide">
        <div className="text-center mb-14 md:mb-20 max-w-2xl mx-auto">
          <div className="opacity-0" data-animate>
            <span className="inline-block px-4 py-1.5 bg-emerald-50 border border-emerald-100 rounded-full text-emerald-600 text-xs md:text-sm font-semibold tracking-wide mb-4">
              What We Do
            </span>
          </div>
          <h2
            className="opacity-0 font-outfit font-bold text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-4"
            data-animate
          >
            SaaS Development
            <br />
            at Scale
          </h2>
          <p
            className="opacity-0 text-base md:text-lg text-gray-500 leading-relaxed"
            data-animate
          >
            From idea to production-ready SaaS. We architect, build, and scale <strong className="text-gray-700">SaaS applications</strong> that power modern businesses and developer teams worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {servicesData.map((service) => (
            <div
              key={service.id}
              data-animate
              className="opacity-0 group p-6 md:p-7 rounded-2xl card-dark card-dark-hover transition-all duration-500 bg-white hover:shadow-lg hover:shadow-emerald-500/5"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-emerald-50 group-hover:bg-emerald-100 flex items-center justify-center mb-5 transition-colors duration-500">
                <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-emerald-600 group-hover:text-emerald-700 transition-colors duration-500">
                  <i className={`${service.icon} text-xl md:text-2xl`} />
                </div>
              </div>
              <h3 className="font-outfit font-semibold text-lg md:text-xl text-gray-900 mb-3 transition-colors duration-500">
                {service.title}
              </h3>
              <p className="text-sm md:text-base text-gray-500 group-hover:text-gray-600 leading-relaxed transition-colors duration-500">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
